import { Badge, Radio, Typography } from '@jisr-hr/ds-beta'
import i18n from 'translations/i18n'

type RadioWithLabelPropsT = {
  value: string | number
  label: string
  description: string
  isEmployeePreference: boolean
  active: boolean
  disabled: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const RadioWithLabel = (props: RadioWithLabelPropsT) => {
  const { value, label, disabled, description, isEmployeePreference, active } = props
  return (
    <div className="flex gap-2">
      <Radio
        value={value}
        active={active}
        disabled={disabled}
        onChange={props.onChange}
      />
      <div className="flex flex-col">
        <div className="flex gap-2">
          <Typography
            text={label}
            variant="body-new/medium"
          />
          {isEmployeePreference && (
            <Badge
              label={i18n.t('label.modal.employee_preference')}
              color="green"
              size="small"
              variant="ghost"
            />
          )}
        </div>
        <Typography
          text={description}
          variant="body-new/medium"
          textColor="color/fg/lighter"
        />
      </div>
    </div>
  )
}

export default RadioWithLabel
